// AST tree helpers for incremental parser segment assembly.
// They keep cache payload immutable across compile cycles.
import type { LuisNode } from '../../types'

// Append parsed segment payload to root node with deep-cloned children.
export function applyParsedSegment(root: LuisNode, declarations: string[], children: LuisNode[]): void {
  // Preserve parsed declaration order for renderer prelude.
  for (const declaration of declarations) {
    root.declarations.push(declaration)
  }

  // Append cloned child nodes into root children list.
  for (const child of children) {
    root.children.push(cloneLuisNode(child))
  }
}

// Deep-clone one AST node to keep cache payload immutable.
export function cloneLuisNode(node: LuisNode): LuisNode {
  // Return cloned node with recursively cloned children.
  return {
    type: node.type,
    value: node.value,
    line: node.line,
    declarations: [...node.declarations],
    children: node.children.map((child) => cloneLuisNode(child)),
  }
}
